import Carousel from 'components/carousel/index.jsx';
import React, { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Creators as CarouselItemCreators } from 'store/carousel-items/carousel-items-duck.js';
import HighlightedSession from './highlighted-session';
import SpecialistsSession from './specialists-session';
import GoogleReviewsWidget from './reviews-session';
import MapFooter from './map-session';

const HomePage = ({ carouselItems, carouselItemsFetchAsync }) => {
  const fetch = useCallback(() => {
    carouselItemsFetchAsync();
  }, [carouselItemsFetchAsync]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return (
    <>
      <Carousel items={carouselItems} autoPlay interval={5000}/>
      <SpecialistsSession />
      <HighlightedSession />
      <GoogleReviewsWidget />
      <MapFooter />
    </>
  );
};

const mapStateToProps = (state) => ({
  carouselItems: state.CarouselItem.items,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(CarouselItemCreators, dispatch);
HomePage.propTypes = {
  carouselItems: PropTypes.array.isRequired,
  carouselItemsFetchAsync: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
